import React from 'react'

export default function Create ({ link }) {
  return <div>CREATE</div>
}
